import {
    InitialQueryState,
    QueryManagerOptions,
    QueryState,
} from '@common/types/queryState';
import { GlobalQuerySchema } from '@constants/queryScema';
import { useMemo } from 'react';
import { useUrlState } from '../useUrlState';
import { useFilterState, usePagination, useSearch, useSorting } from './index';

export const useQueryManager = (
    initialState: InitialQueryState = {},
    options: QueryManagerOptions = {},
) => {
    const { paramsOverride, prefix, skipUrlSync, delay } = options;
    const { state, setState, reset } = useUrlState<QueryState>(
        GlobalQuerySchema,
        initialState,
        { skipUrlSync, prefix },
    );

    const queryState: QueryState = useMemo(
        () => ({
            ...state,
            ...(paramsOverride || {}),
        }),
        [state, paramsOverride],
    );

    const searchState = useSearch(queryState.search, setState, delay);
    const paginationState = usePagination(
        queryState.pageIndex,
        queryState.pageSize,
        setState,
    );
    const sortingState = useSorting(queryState.sorting, setState);
    const filterState = useFilterState(
        queryState.facets,
        queryState.ranges,
        setState,
    );

    return {
        queryState,
        searchState,
        paginationState,
        sortingState,
        filterState,
        resetState: reset,
    };
};
